<template>
  <v-main>
    <v-container fluid class="fill-height">
      <v-row>
        <v-col>
          <v-card class="mx-auto b-4" max-width="500">
            <v-toolbar color="secondary">
              <v-toolbar-title>Your General Practitioner</v-toolbar-title><v-spacer></v-spacer>
                <EditGP />
            </v-toolbar>
  
            <v-card class="ma-4 mb-5" v-if="address">
              
              <v-card-title class="body-2 pb-0">Surgery Name:</v-card-title>
              <v-card-text class="text-h6 pl-6"> {{ address.practice_name }} </v-card-text>
              <v-card-title class="body-2 pb-0">Surgery Address:</v-card-title>
              <v-card-text class="text-h6 pl-6 ">{{ address.practice_address}} </v-card-text>
              <v-card-title class="body-2 pb-0">Surgery Phone:</v-card-title>
              <v-card-text class="text-h6 pl-6">{{ address.practice_phone }} </v-card-text>
            </v-card>
            <v-card-text class="pa-5 text-h6" v-else>You can select a GP Surgery clicking the Select button above</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapGetters } from "vuex"
import EditGP from "@/components/dialogs/EditGP"
export default {
  created() {
    this.$store.dispatch("gp/aGetGp");
  },
  computed: {
    ...mapGetters("gp", {
      address: "gAddress"
    })
  },
  components: {
    EditGP
  }

}
</script>

<style>

</style>